import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getBureauReports = serviceBase({
  request: options =>
    axiosClient.get('/buro-reports', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const getBuroReportDetails = serviceBase({
  request: ({ reportId, ...options }) =>
    axiosClient.get(`/buro-reports/${reportId}/detail`, {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadBureauReportCSV = serviceBase({
  request: options =>
    axiosClient.get('/buro-reports/export', {
      responseType: 'blob',
      params: options,
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = `Reporte-Buro-${
        new Date().toISOString().split('T')[0]
      }.csv`;
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});
